
import {CHANGE_SEARCH_FIELD,
    REQUEST_ROBOTS_PENDING,REQUEST_ROBOTS_SUCCESS
    ,REQUEST_ROBOTS_FAILED} from './constants';

const statesearch={
    searchField:''
}
export const searchRobots=(state=statesearch,action={})=>{
    switch (action.type) {
        case CHANGE_SEARCH_FIELD :
            return Object.assign({},state,{searchField : action.payload});
        default :
        return state;
    }
}
const initialrobostate={
    inPending: false,
    robots: [],
    err: ''
}
export const getRobots=(state=initialrobostate,action={})=>{
    switch(action.type){
        case REQUEST_ROBOTS_PENDING:
            return Object.assign({},state,{isPending: true});
        case REQUEST_ROBOTS_SUCCESS :
            return Object.assign({},state,{isPending: false, robots: action.payload});
        case REQUEST_ROBOTS_FAILED:
            return Object.assign({},state,{isPending: false, err: action.payload})
        default :
            return state;
    }
}



